module.exports = require("./../../_gen/starling/rendering/Painter");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/rendering/Painter.js
// module id = 215
// module chunks = 0